import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Row, Col, Card, Button, Tooltip, OverlayTrigger, Modal } from 'react-bootstrap';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import { motion } from 'framer-motion';
// import Confetti from 'react-confetti';
// import { useSpring, animated } from '@react-spring/web';
// utils
import { handleAPIError, handleCatchError } from 'utils/handleErrors';
import { initialsUpperCase } from 'utils/textFormat';
import formatMoney from 'utils/formatMoney';

// components
import { ToastSuccess } from 'components/alerts/toast';
import NotificationModal from './components/NotificationModal';
import NotificationGallery from '../../../components/carousel/NotificationsGallery';
import ButtonRequest from '../../../components/buttons/ButtonRequest';
// api
import { getAllNotices, deleteNotice, getHomeCounters } from '../../api/Api-admin';

const AdminDashboard = () => {
  // - Global State from Store.js form Values
  const { currentUser } = useSelector((state) => state.auth);
  const [notifications, setNotifications] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [notificationSelected, setNotificationSelected] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const [isDeleteNoticeLoader, setIsDeleteNoticeLoader] = useState(false);
  // const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const containerRef = useRef(null);
  const [counters, setCounters] = useState({
    depositsDay: 0,
    depositsMonth: 0,
    shippingsDay: 0,
    shippingsMonth: 0,
    users: 0,
  });
  const [quote, setQuote] = useState('');
  const [author, setAuthor] = useState('');
  // const [showConfetti, setShowConfetti] = React.useState(true);

  const handlerGetNotices = async () => {
    try {
      const response = await getAllNotices();
      // console.log('avisos lista:', response);
      if (response.notices !== undefined) {
        setNotifications(response.notices);
      }
    } catch (error) {
      handleCatchError(error);
    }
  };
  const handlerHomeCounters = async () => {
    try {
      const response = await getHomeCounters();
      // console.log('response home counters:', response);
      if (response.notices !== undefined) {
        setCounters({
          depositsDay: response.deposits_per_day,
          depositsMonth: response.deposits_per_month,
          shippingsDay: response.shippings_per_day,
          shippingsMonth: response.shippings_per_month,
          users: response.total_users,
          ...response,
        });
      }
    } catch (error) {
      handleCatchError(error);
    }
  };
  const handlerDeleteNotice = async () => {
    try {
      setIsDeleteNoticeLoader(true);
      const response = await deleteNotice(notificationSelected.id);
      if (response.success !== undefined) {
        // refrescar pagina
        setTrigger(!trigger);
        setIsDeleteModalOpen(false);
        ToastSuccess('Notificación eliminada correctamente ✨');
      } else if (response.error) {
        handleAPIError(response);
      }
    } catch (error) {
      handleCatchError(error);
    } finally {
      setIsDeleteNoticeLoader(false);
    }
  };

  const phrases = [
    { phrase: 'El trabajo en equipo engrandece a las personas y a las empresas.', author: 'Rodri' },
    { phrase: 'Sé agradecido por lo que tienes, y terminarás teniendo más.', author: 'Vale' },
    {
      phrase: 'El sacrificio es necesario para alcanzar el éxito. Si no estás dispuesto a dejar algo atrás, nunca llegarás a donde quieres estar.',
      author: 'Dani',
    },
    {
      phrase:
        'Aprendí que el liderazgo no se trata de la personalidad del líder, sino de la capacidad de reconocer las habilidades de los demás y aprovecharlas al máximo.',
      author: 'Hector',
    },
    { phrase: 'Todas las cosas son creadas dos veces: primero en la mente, luego en la realidad.', author: 'Vivi' },
    { phrase: 'Hoy semillas, mañana flores. 🌼', author: 'Nat' },
    { phrase: 'Entre mas dificil, más grande es el triunfo. ✨', author: 'Mili' },
    { phrase: 'Mientras más grande es el sueño, más importante es el equipo.', author: 'Manfre' },
    { phrase: 'El fracaso es parte de la vida, si no fracasas, no aprendes y si no aprendes, no cambias.', author: 'Blanquita' },
    { phrase: 'Nos debe acompañar siempre la satisfacción de lo dificil.', author: 'Bety' },
    // { phrase: 'p', author: 'Pau' },
    { phrase: 'Un pequeño esfuerzo sostenido es más poderoso que un gran esfuerzo efímero.', author: 'Julio' },
  ];

  const getRandomInt = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  const getRandomPhrase = () => {
    const item = phrases[getRandomInt(0, phrases?.length - 1)];
    setQuote(item?.phrase);
    setAuthor(item?.author);
  };
  useEffect(() => {
    getRandomPhrase();
  }, []);
  useEffect(() => {
    handlerGetNotices();
    handlerHomeCounters();
  }, [trigger]);
  // useEffect(() => {
  //   // Confeti dura 5 segundos
  //   const timer = setTimeout(() => setShowConfetti(false), 50000);
  //   return () => clearTimeout(timer);
  // }, []);
  // useEffect(() => {
  //   if (containerRef.current) {
  //     // console.log('valor de conteinerRef.current:', containerRef.current);
  //     const { offsetWidth, offsetHeight } = containerRef.current;
  //     setDimensions({ width: offsetWidth, height: offsetHeight });
  //   }
  // }, []);
  // const WalkingCharacter = ({ src, startX, endX, top, duration }) => {
  //   const animationProps = useSpring({
  //     from: { transform: `translateX(${startX}px)` },
  //     to: { transform: `translateX(${endX}px)` },
  //     loop: true,
  //     config: { duration },
  //   });

  //   return (
  //     <animated.img
  //       src={src}
  //       alt="Walking Character"
  //       style={{
  //         position: 'fixed',
  //         top,
  //         height: '100px',
  //         zIndex: 1000,
  //         ...animationProps,
  //       }}
  //     />
  //   );
  // };

  return (
    <div className="bg-infox" ref={containerRef}>
      {/* Start Birthday Elements height={window.innerHeight} width={window.innerWidth}  width={dimensions.width} height={dimensions.height} */}
      {/* {showConfetti && <Confetti width={window.innerWidth} height={dimensions.height} />} */}
      {/* <WalkingCharacter src="/img/illustration/icon-vader.png" startX={-150} endX={window.innerWidth} top="60%" duration={8000} /> */}
      {/* <WalkingCharacter src="/img/illustration/4.png" startX={-200} endX={dimensions.width} top="80%" duration={10000} /> */}
      {/* <WalkingCharacter src="/img/illustration/5.png" startX={dimensions.width} endX={-150} top="40%" duration={12000} /> */}
      {/* End Birthday Elements */}

      <NotificationModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        notification={notificationSelected}
        setNotificationSelected={setNotificationSelected}
        setTrigger={setTrigger}
        trigger={trigger}
      />
      <Modal
        show={isDeleteModalOpen}
        onHide={() => {
          setIsDeleteModalOpen(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-primary">
            <span className="text-alternate">Eliminar notificación</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-infow">
          <div className="text-semi-large">¿Estas segur@ de que deseas eliminar esta notificación?</div>
          <div className="text-primary ms-2 mt-3">{notificationSelected.title}</div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex flex-wrap justify-content-end bg-warningd">
            <ButtonRequest
              title="Si, eliminar"
              titleLoading="Cargando"
              handlerFn={handlerDeleteNotice}
              isButtonDisabled={isDeleteNoticeLoader}
              isLoading={isDeleteNoticeLoader}
            />
            <Button variant="outline-primary" style={{ height: '36px' }} className="w-auto ms-2 mb-2" onClick={() => setIsDeleteModalOpen(false)}>
              Cancelar
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      <Row className="g-0 bg-successx">
        <Col lg="7" className="pe-3 ">
          <div className=" bg-azul px-3 py-2 rounded-10 mb-5">
            <h1 className="mb-0 pb-0 display-4 text-center text-sm-start lh-base  text-white" id="title">
              {`ioenvio administrador `}
            </h1>
            <motion.div
              initial={{ opacity: 0, x: -100 }} // Sale desde la izquierda
              animate={{ opacity: 1, x: 0 }} // Aparece en su posición original
              transition={{ duration: 0.5, ease: 'easeOut' }} // Transición suave
            >
              <h2 className="small-title invisible">admin</h2>
              <Row className="g-2 row-cols-2 row-cols-md-3 row-cols-xl-4 mb-2">
                {/* <Col className="sh-19">
                <Card className="h-100 d-flex justify-content-center align-items-center bg-primary">
                  <img src="../img/logo/ioenvio-r.png" alt="logo" width="50px" />
                </Card>
              </Col> */}
                <Col lg="3" className="sh-19">
                  <Card className="h-100">
                    <Card.Body className="d-flex flex-column aling-items-center anchor-effect-primary">
                      <img alt="agent" width="45px" className="rounded-circle mx-auto" src="/img/profile/profile-5.webp" />
                      {/* <img alt="agent" width="50px" className="rounded-circle mx-auto" src="/img/illustration/icon-yoda.png" /> */}
                      <div className="text-primary  font-weight-bold mt-2 mx-auto">{`${initialsUpperCase(currentUser.name)} `}</div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col lg="3" className="sh-19">
                  <OverlayTrigger delay={{ show: 1000, hide: 0 }} placement="top" overlay={<Tooltip id="tooltip-top">Ir a usuarios</Tooltip>}>
                    <NavLink to="/users-all" className="anchor-effect-primary">
                      <Card className="h-100">
                        <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                          <CsLineIcons icon="group" className="text-primary w-40 h-100 w-sm-25 w-md-30 w-lg-50 mw-45" />
                          <p className="heading mt-3 text-blue-dark">Usuarios</p>
                          <p className="text-medium text-primary font-weight-bold">{counters.users}</p>
                        </Card.Body>
                      </Card>
                    </NavLink>
                  </OverlayTrigger>
                </Col>
                <Col lg="3" className="sh-19">
                  <OverlayTrigger delay={{ show: 1000, hide: 0 }} placement="top" overlay={<Tooltip id="tooltip-top">Ir a envíos</Tooltip>}>
                    <NavLink to="/shipping-all" className="anchor-effect-primary">
                      <Card className="h-100">
                        <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                          <CsLineIcons icon="carrito" className="text-primary  w-40 h-100 w-sm-25 w-md-30 w-lg-50 mw-45" />
                          <p className="heading mt-3 text-blue-dark">Envíos</p>
                          <p className="text-medium text-primary font-weight-bold">{counters.shippingsDay}</p>
                        </Card.Body>
                      </Card>
                    </NavLink>
                  </OverlayTrigger>
                </Col>
                <Col lg="3" className="sh-19">
                  <OverlayTrigger delay={{ show: 1000, hide: 0 }} placement="top" overlay={<Tooltip id="tooltip-top">Ir a usuarios</Tooltip>}>
                    <NavLink to="/users-all" className="anchor-effect-primary">
                      <Card className="h-100">
                        <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                          <CsLineIcons icon="factura" className="text-primary  w-40 h-100 w-sm-25 w-md-30 w-lg-50 mw-45" />
                          <p className="heading mt-3 text-blue-dark">Facturación</p>
                          <p className="text-medium fw-medium text-primary font-weight-bold">{formatMoney(counters.depositsDay, { symbol: '$' })}</p>
                        </Card.Body>
                      </Card>
                    </NavLink>
                  </OverlayTrigger>
                </Col>
              </Row>
            </motion.div>
          </div>

          <motion.div
            initial={{ opacity: 0, x: -100 }} // Sale desde la izquierda
            animate={{ opacity: 1, x: 0 }} // Aparece en su posición original
            transition={{ duration: 0.5, ease: 'easeOut' }} // Transición suave
          >
            <Row className="g-2 mb-5">
              {/* <Col sm="12">
                <Card>
                  <Card.Body>
                    <Card>
                      <Card.Body className="rounded" style={{ boxShadow: '0 4px 6px rgba(var(--separator-rgb), 0.5)' }}>
                        <p className="quote mt-2">
                          Hoy la galaxia entera celebra tu existencia, y los Jedi te honran como un guardián de la luz. Que este año sea épico, lleno de
                          aventuras y momentos inolvidables. ¡Feliz cumpleaños, Padawan! Y recuerda… el miedo lleva al lado oscuro, así que hoy solo hay espacio
                          para la alegría y la diversión. ¡Disfruta tu día al máximo!
                        </p>
                        <Col xs="12">{`"Mucho celebrar hoy debes, Julio. La Fuerza contigo fuerte está. ¡Feliz cumpleaños!" ✨ - Yoda  `}</Col>
                      </Card.Body>
                    </Card>
                  </Card.Body>
                </Card>
              </Col> */}
              <Col sm="12">
                <Card>
                  <Card.Body>
                    <Row>
                      <Col xs="11" className="text-black">
                        <b>{`¡Hola, ${initialsUpperCase(currentUser.name)}! Aquí tienes las frases favoritas del equipo. 😊 `}</b>
                      </Col>
                      <Col xs="1" className="d-flex justify-content-end">
                        <div onClick={getRandomPhrase}>
                          <CsLineIcons icon="rotate-left" className="anchor-effect-primary me-2 cursor-pointer" onClick={getRandomPhrase} />
                        </div>
                      </Col>
                    </Row>
                    <Card className="mt-4">
                      <Card.Body className="rounded py-2" style={{ boxShadow: '0 4px 6px rgba(var(--separator-rgb), 0.5)', background: 'var(--background)' }}>
                        <p className="quote">
                          <small>
                            <i>"{quote}"</i>
                          </small>
                        </p>
                        <p className="author mb-2">
                          <small>- {author}</small>
                        </p>
                      </Card.Body>
                    </Card>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </motion.div>
        </Col>

        <Col lg="5">
          <motion.div
            initial={{ opacity: 0, x: 100 }} // Sale desde la derecha
            animate={{ opacity: 1, x: 0 }} // Aparece en su posición original
            transition={{ duration: 0.5, ease: 'easeOut' }} // Transición suave
          >
            <Card>
              <Card.Body className="bg-alternatex p-2">
                {/* {notifications.length > 0 && <NotificationGallery notifications={notifications} />} */}
                <div className={`mt-0 ${currentUser.role === 'Control Medio' ? 'd-none' : 'd-block'}`}>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h2 className="text-semi-large text-primary m-0">Notificaciones</h2>
                    <Button
                      className="w-auto btn-over-dark ms-0 ms-sm-1 p-0 bg-white text-primary d-flex justify-content-end gap-2 border-0"
                      onClick={() => {
                        setIsModalOpen(true);
                      }}
                    >
                      <span className="ps-2 text-semi-large ">Crear nueva</span>
                      <CsLineIcons icon="plus_add" />
                    </Button>
                  </div>
                  {notifications.length > 0 ? (
                    notifications?.map((notice, index) => (
                      <Card className="mb-3 " key={index}>
                        <Row className="g-0 h-auto sh-lg-6 position-relative">
                          <Col xs="auto" className="positio-relative">
                            {/* <img src={notice.img} alt="servicio" className="card-img card-img-horizontal sw-11 h-100" /> */}
                          </Col>
                          <Col
                            className="py-2 py-lg-2 ps-2 pe-2 h-auto card  "
                            style={{ boxShadow: '0 4px 6px rgba(var(--separator-rgb), 0.5) !important', background: 'var(--background)' }}
                          >
                            <Row className="g-0 h-auto  align-content-center">
                              <Col xs="10" className="d-flex flex-column mb-lg-0 mb-2 pe-2 d-flex order-1 h-lg-auto justify-content-center order-1">
                                <div className="text-medium text-small">Titulo</div>
                                <div className="text-primary">{notice.title}</div>
                              </Col>
                              <Col xs="2" className="ps-4 d-flex mb-2 mb-lg-0 align-items-center justify-content-end order-1 order-lg-last">
                                <div
                                  onClick={() => {
                                    setNotificationSelected(notice);
                                    setIsModalOpen(true);
                                  }}
                                >
                                  <CsLineIcons icon="edit" className="anchor-effect-primary me-2 cursor-pointer" />
                                </div>
                                <div
                                  onClick={() => {
                                    setNotificationSelected(notice);
                                    setIsDeleteModalOpen(true);
                                  }}
                                >
                                  <CsLineIcons icon="bin" className="anchor-effect-primary cursor-pointer" />
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Card>
                    ))
                  ) : (
                    <div>No hay notificaciones disponibles</div>
                  )}
                </div>
              </Card.Body>
            </Card>
          </motion.div>
        </Col>
      </Row>
    </div>
  );
};

export default AdminDashboard;
